import { defineEndpoints } from '@blockworks/platform/api';

const BEEHIIV_ENDPOINTS = defineEndpoints(template => ({
    GET: {
        POSTS: template(`/api/beehiiv/publications/{publicationId}/posts`),
        PUBLICATIONS: template(`/api/beehiiv/publications`),
    },
    POST: {
        SUBSCRIBE: template(`/api/beehiiv/publications/{publicationId}/subscriptions`),
    },
}));

export { BEEHIIV_ENDPOINTS };
